import {Component, OnInit, Input} from '@angular/core';

@Component({
    selector: 'bubble-chart',
    templateUrl: './bubble-chart.component.html',
    styleUrls: ['./bubble-chart.component.css']
})
export class BubbleChartComponent implements OnInit {

    threatLevels: string[] = ['LOW', 'MEDIUM', 'HIGH'];
    colorClasses = ['bg-risk-low', 'bg-risk-medium', 'bg-risk-high'];
    sizeClasses = ['p-0', 'p-20', 'p-40', 'p-60', 'p-80', 'p-100'];
    icons = ['bomb', 'bug', 'sliders', 'crosshairs', 'info-circle'];
    blankTooltip: any = {
        left: -1000,
        top: -1000,
        width: 200
    };
    tooltip: any = Object.assign({}, this.blankTooltip);

    @Input() data = {};


    private mockData = {
        x: {
            labels: [ 'x0', 'x1', 'x2', 'x3', 'x4', 'x5', 'x6' ]
        },
        y: {
            labels: [ 'y0', 'y1', 'y2', 'y3', 'y4' ]
        },
        series: [
            [
                [ [0, 0], [1, 1], [2, 2], [0, 3], [1, 4], [2, 5] ],
                [ [0, 5], [1, 1], [0, 5], [0, 5], [0, 5], [0, 5] ],
                [ [0, 0], [0, 0], [2, 2], [0, 0], [0, 0], [0, 0] ],
                [ [0, 0], [0, 0], [0, 0], [0, 3], [0, 0], [0, 0] ],
                [ [0, 0], [0, 0], [0, 0], [0, 0], [1, 4], [0, 0] ],
                [ [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [2, 5] ],
                [ [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0] ]
            ],
            [
                [ [0, 0], [1, 1], [2, 2], [0, 3], [1, 4], [2, 5] ],
                [ [0, 0], [1, 1], [0, 0], [0, 0], [0, 0], [0, 0] ],
                [ [0, 0], [0, 0], [2, 2], [0, 0], [0, 0], [0, 0] ],
                [ [0, 0], [0, 0], [0, 0], [0, 3], [0, 0], [0, 0] ],
                [ [0, 0], [0, 0], [0, 0], [0, 0], [1, 4], [0, 0] ],
                [ [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [2, 5] ],
                [ [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0] ]
            ]
        ]
    };

    constructor() {

    }

    ngOnInit() {
        // his.data = this.mockData;
    }

    getClassForBubble(bubble) {
        return this.colorClasses[bubble[0]] + ' ' + this.sizeClasses[bubble[1]];
    }

    hasNoActivity(timeSlot) {
        return timeSlot.every(function(bubble){
            return bubble[1] === 0;
        });
    }

    onBubbleMouseOver(evt, bubble) {

        this.tooltip.type = bubble.type;
        this.tooltip.date = bubble.date;
        this.tooltip.threatLevel = this.threatLevels[parseInt(bubble.threatLevel, 10)];
        this.tooltip.count = parseInt(bubble.count, 10);

        this.tooltip.left = evt.clientX - (this.tooltip.width / 2);
        this.tooltip.top = evt.clientY;

    }

    onBubbleMouseOut() {
        this.tooltip = Object.assign({}, this.blankTooltip);
    }

}



// WEBPACK FOOTER //
// /app/src/app/components/bubble-chart/bubble-chart.component.ts